// This class manages the status message in the fault details page.
// It shows help text based on whether a fault is resolved, unresolved or has been paused.
// Because so many unconnected things can affect the message to be shown here
// it's a little more complex than you'd think.
//
// It's basically a prioritized message queue. The highest priority message is displayed.
// When it gets cleared, the 2nd highest is displayed. Messages already in the queue can
// be updated, even if they're not currently being displayed.
//

import Components from "../components";

class FaultStatusMessage extends Components.Base {
  initialize() {
    this.messages = {};
  }

  bind() {
    this.updateFn = (...args) => this.update(...args);
    $("body").on("fault-status-message:update", this.updateFn);
  }

  unbind() {
    $("body").off("fault-status-message:update", this.updateFn);
  }

  update(e, data) {
    if (data.message) {
      this.messages[data.source] = data;
    } else {
      delete this.messages[data.source];
    }
    this.render();
  }

  prioritizedMessages() {
    return Object.values(this.messages).sort((a, b) => b.priority - a.priority);
  }

  highestPriorityMessage() {
    const item = this.prioritizedMessages()[0];
    return item ? item.message : "";
  }

  render() {
    return this.$el.html(this.highestPriorityMessage());
  }
}

Components.collection.register({
  selector: ".c-fault-status-message",
  klass: FaultStatusMessage,
});
